import React from "react";
import profileService from "../services/profileService";

export const getUserBalance = (updateUserBalance) => {
  profileService
    .userBalance({})
    .then((response) => {
      if (
        response &&
        response.getVoucherBalance &&
        response.getVoucherBalance.error == false
      ) {
        let data = {
          currencySymbol:
            response.getVoucherBalance.data.formatted["currencySymbol"],
          userBalance: response.getVoucherBalance.data.formatted["balance"],
          companyBalance:
            response.getVoucherBalance.data.formatted["companyBalance"],
          currencyValue:
            response.getVoucherBalance.data.formatted["currencyValue"],
          currencyCode:
            response.getVoucherBalance.data.formatted["currencyCode"],
        };
        updateUserBalance(data);
      }
    })
    .catch((error) => {});
};
